<template>
  <div class="container-fluid">
    <div class="row justify-content-center">
      <div class="col-12">
        <indexHeader
          :title="$t('employeesDeductions.EmployeeDiscounts')"
          :description="$t('employeesDeductions.FromHereYouCanFollowTheEmployeeDiscounts')"
        />
        <indexTable
          :searchText="$t('employeesDeductions.SearchForAnOperation')"
          :emptyTableText="$t('employeesDeductions.ThereAreNoDiscounts')"
          :emptyTableSubText="$t('allerts.TryAddingSomeItemsToTheTableAndTryAgain')"
          :buttonRole="$checkRole('employees_deductions_add')"
          :statusSearch="true"
          :statusValues="[
            { title: $t('orders.situation'), value: '' },
            { title: $t('orders.all'), value: '' },
            { title: $t('invoices.draft'), value: 0 },
            { title: $t('invoices.approved'), value: 1 }
          ]"
          :cloumns="[
            {
              column: 'code',
              title: $t('employeesDeductions.Discount'),
              type: 'mainLink',
              sort: true
            },
            {
              column: 'employee_id',
              title: $t('employeesDeductions.functionary'),
              type: 'link',
              to: 'employee',
              sort: true,
              link: true
            },
            {
              column: 'date',
              title: $t('employeesDeductions.date'),
              type: 'text',
              sort: true
            },
            {
              column: 'description',
              title: $t('employeesDeductions.thatsAbout'),
              type: 'text',
              sort: true
            },
            {
              column: 'notes',
              title: $t('employeesDeductions.note'),
              type: 'text',
              sort: true
            },
            {
              column: 'cost',
              title: $t('employeesDeductions.cost'),
              type: 'text',
              sort: true,
              after: $option.currency
            },
            {
              column: 'user_name',
              title: 'اسم المسئول',
              type: 'text',
              sort: true
            },
            {
              column: 'status',
              title: $t('bills.situation'),
              type: 'status',
              sort: true,
              values: [
                { title: $t('invoices.draft'), value: 0, color: 'dark' },
                { title: $t('invoices.approved'), value: 1, color: 'success' }
              ]
            },
            {
              column: 'options',
              title: $t('employeesDeductions.Settings'),
              type: 'options',
              options: [
                { name: 'show' },
                { name: 'printEmployeesDeduction', role: true },
                {
                  name: 'edit',
                  role: $checkRole('employees_deductions_edit')
                },
                { name: 'file' },
                { name: 'download', role: true },
                {
                  name: 'delete',
                  role: $checkRole('employees_deductions_delete')
                }
              ]
            }
          ]"
          :deleteText="{
            attention: $t('allerts.Attention'),
            areYouReallySureToDeleteTheItem: $t('allerts.areYouReallySureToDeleteTheItem'),
            close: $t('allerts.close'),
            confirm: $t('allerts.confirm'),
            loading: $t('allerts.loading')
          }"
        />
      </div>
    </div>
  </div>
</template>
<script>
import indexHeader from '@/elements/index/indexHeader.vue'
import indexTable from '@/elements/index/indexTable.vue'

export default {
  data() {
    return {
      path: '/employeesDeductions'
    }
  },
  components: {
    indexHeader,
    indexTable
  }
}
</script>
